<template>
  <v-app class="bcgrnd">
    <v-container fluid grid-list-md text-xs-center style="background-color:#f4f4f4 ;padding: 0;" >
      <v-card flat style="background-color:#f4f4f4" >
    <v-card-title style="padding:0px">
      <h5>Upload Student Document</h5>
      <v-spacer></v-spacer>



    <v-btn @click.stop="logOutDialog = true" round flat style="text-transform: unset !important ;background-color: #ffffff; ">
                        <!-- <avatar :size="32" :username="loggedInUserName"></avatar> -->
                        <v-icon color="warning" style="font-size:30px;">person</v-icon>

                       &nbsp;&nbsp;{{loggedInUserName}}
      <!-- <v-icon>arrow_drop_down</v-icon> -->

    </v-btn>

          <v-dialog v-model="logOutDialog" max-width="290" persistent>
            <v-card style="padding: 20px !important ; border-radius: 0px;border:1px solid;background-color:orange">
              <v-sheet color="transparent" style="text-align:center">
                <v-icon color="#0d47a1" :size="40">https</v-icon>
              </v-sheet>
              
              <h3 style="text-align:center;font-size:20px;color:red">Logout</h3>

   <v-card-text style="text-align:center;color:black">Are you sure you want to logout from Worldwin ?</v-card-text>

              
                <v-btn style="padding-left:60px" dark color="green" flat @click="logOutDialog = false">No</v-btn>&nbsp;&nbsp;
                <v-btn dark color="red" flat @click="logOut()">Yes</v-btn>
            </v-card>
          </v-dialog>
    </v-card-title>
  </v-card>
    </v-container>
  

    <v-container  style="max-width:1350px">
    <v-layout row wrap class="my-2 mx-2" >


      <v-flex xs12 sm12 md12>
        <template>
              <v-card class="form-container" style=" padding: 35px;">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 >
                <v-autocomplete
                                  v-model="selectedType"
                                  :items="types"
                                  label="Select Document Type *"
                                  item-text="name"
                                  item-value="id"
                                  :rules="emptyRule"
                                  required
                                  ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm12 md6></v-flex>
              <!-- <v-flex xs12>
                <b-form-radio-group
                  v-model="selectedFormat"
                  :options="formats"
                  class="mb-3"
                ></b-form-radio-group>
              </v-flex> -->
              <v-flex xs12>
                  <input type="file" ref="myFile" @change="selectedFile"  class="padding" accept="image/*">
              </v-flex>
              <v-flex xs12>
                  <h6 v-if="imagelink != null">Image Size : {{image.size}}</h6>
                  <h6 class="red--text">{{imageError}}</h6>
              </v-flex>

              <v-flex xs12>
                <v-btn depressed :loading="btnSave" color="primary" dark @click="onSubmit()" style="margin:5px">Save </v-btn>
                <v-btn depressed color="orange" dark @click="back()" style="margin:5px">Cancel</v-btn>
              </v-flex>
            </v-layout>
          </v-form>
            </v-card>
        </template>
        </v-flex>

    </v-layout>
  </v-container>

  </v-app>
</template>

<script>

//import Vue from "vue";
import config from "../../config1.json";
export default {
  components: {
  },
  data() {
    return {
      roleType: sessionStorage.roles,
      loggedInUserName: sessionStorage.loggedInUserName,
      logOutDialog: false,
      customerNo: 0,
      productNo: 0,
      presentOrderList: [],
      itemAdded: [],
      presentOrder: 0,
      presentOrderAmount: 0,
      deliveredOrderAmount: 0,
      deliveredOrder: 0,

      leadDetail: {},

      search: "",
      tableHeader: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Order Code", value: "orderCode" },
        { text: "Order Date", value: "date" },
        { text: "Customer Name", value: "fullName" },
        { text: "Mobile Number", value: "mobileNumber" },
        { text: "Total Amount", value: "totalPrice" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" }
      ]
    };
  },

  methods: {
 

    getData() {
      let id = sessionStorage.getItem("loggedInUserID");
      this.axios
      .get(config.API + 'Admin/' + id, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let studentId = 30;

        this.axios
        .get(config.API + `UniversityRegistrations/` + studentId, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          console.log(res);
          this.leadDetail = res.data.leadDetail;   
          //console.log(this.leadDetail);     
          this.$Progress.finish();
        });
      });
    },



    onEdit(item) {
      this.$router.push(`/viewSalesOrder/${item.id}`);
    },

    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
  },

  created() {
    this.getData();
  }
};
</script>

<style scoped>
.bcgrnd {
  background-color: white !important;
  background-size: cover;
}
.v-card {
  padding: 25px;
  letter-spacing: 0.5px;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
.txt_dec:hover {
    text-decoration: none !important;
}
.flashing_effect {
  background-color: green !important;
  /* background-image: linear-gradient(-90deg, #f44336, #280071); */
  /* padding: 12px 15px; */
  animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes flashing{
  0% {
     opacity: 1.0;
  }
  25% {
     opacity: 0.6;
  }
  50% {
     opacity: 0.3;
  }
  75% {
     opacity: 0.6;
  }
  100% {
     opacity: 1.0;
  }
}
marquee {
  height: 85%;
}
.hvr:hover {
  cursor: pointer;
  color: #3486D7;
  text-decoration: underline;
}
.das-card i{
   font-size: 30px;
   margin-right: 8px;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
.mobile-heading {
  font-size: 30px;
}
}
@media screen and (min-width: 768px){
  .man {
    display: none!important;
  }
}

.das-card {
  text-align: center;
}
.table-light tr td{
  font-size: 18px!important; 
  color: #F09522;
}
.table-light tr{

}
.table-tbody tr td{
  text-align: center;
   font-size: 18px!important;
}
</style>
